import { ChevronRightIcon } from "@heroicons/react/outline";
import { MeetingHeaderFragmentFragment } from "types/graphql-schema";

import { leftSidePanelVar } from "@cache/cache";
import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import { getUrl } from "@helpers/helpers";

const MeetingBreadcrumb = ({
  meeting,
}: {
  meeting?: MeetingHeaderFragmentFragment | null;
}) => {
  return (
    <div className="flex gap-0.5 items-center text-sm text-gray-600 flex-1 min-w-0">
      <Button
        theme={buttonTheme.text}
        size={ButtonSize.medium}
        className="hidden @3xl/layout-header:flex"
        to="/meetings"
        onClick={(e) => {
          e.preventDefault();
          leftSidePanelVar("meetings");
        }}
      >
        Meetings
      </Button>
      {meeting && (
        <div className="flex gap-0.5 items-center text-sm text-gray-600 min-w-0">
          <ChevronRightIcon className="h-3 w-3 text-gray-500 hidden @3xl/layout-header:flex" />
          <Button
            theme={buttonTheme.text}
            size={ButtonSize.medium}
            to={getUrl({
              meetingGroupId: meeting.meetingGroupId,
              meetingId: meeting.id,
            })}
            className="flex-1 min-w-0 hidden @[400px]/layout-header:flex"
          >
            <span className="truncate">{meeting.title}</span>
          </Button>
        </div>
      )}
    </div>
  );
};

export default MeetingBreadcrumb;
